<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <div v-if="loginDefine.length > 1">
      <a-tabs default-active-key="0">
        <a-tab-pane v-for="(item, index) in loginDefine" :key="String(index)" :tab="item.name" force-rende>
          <component :is="item.component" @getLoginAccount="getLoginAccount" />
        </a-tab-pane>
      </a-tabs>
    </div>
    <div v-else>
      <component :is="loginDefine[0].component" @getLoginAccount="getLoginAccount" />
    </div>
    <div v-if="logoUi.appId=='10016'">
      <Privacy />
    </div>
  </div>
</template>

<script>

import { message } from 'ant-design-vue';

import api from '@/api';
import { post } from '@/utils/http';

// import { pointTools } from '@/utils/point';
import Baseunified from '@/utils/micro/baseunified';
import { getLogo } from '@/utils/intConfiguration';
import AccountLogin from './accountLogin.vue';
import VerificationLogin from './verificationLogin.vue';
// eslint-disable-next-line import/no-unresolved
import UserNameLogin from './useNameLogin.vue';

import {
  setAccount,
  setUserSys,
  setUserZnEnv,
} from '../../login-handler';

import Privacy from './privacy.vue';

const baseModel = new Baseunified();
const { envList } = require('../../../../../config/dev.proxy');
import { getUiFitment } from '@/utils/accessResources';

export default {
  name: 'ZnLogin',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AccountLogin,
    // eslint-disable-next-line vue/no-unused-components
    VerificationLogin,
    UserNameLogin,
    Privacy,
  },
  data() {
    return {
      logoUi: getLogo(),
      loginDefine: baseModel.getLoginDefine(),
    };
  },
  created() {
    // pointTools.traceClick({
    //   event_type: 'page_view',
    //   content: {
    //     event_id: 'page_login',
    //     event_name: '登录页',
    //   },
    // });
  },
  mounted() {
    // console.error(this.logoUi);
  },
  methods: {
    // TODO线上缓存 （适配apaas+告警sdk apaas调整结构，统一网络库后 废弃）
    initenv() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      function prdZnv() {
        // eslint-disable-next-line no-unused-vars
        let isProduct = true;
        envList.forEach((m) => {
          if (window.location.hostname.toString().includes(m)) {
            isProduct = false;
            setUserZnEnv(m);
            setUserSys(_this.logoUi.appId);
          }
        });
        if (isProduct) {
          isProduct = _this.laneFitting();
        }
        if (isProduct) {
          setUserZnEnv('product');
          // 本地ng转发后 appId未定义问题
          // eslint-disable-next-line no-underscore-dangle
          const _host = window.location.hostname.toString();
          if (!_host.includes('192') && !_host.includes('localhost')) {
            setUserSys(_this.logoUi.appId);
          }
        }
      }
      if (process.env.NODE_ENV !== 'development') {
        prdZnv();
      }
    },
    // TODO 泳道环境测试 适配方法 仅供泳道验证使用
    laneFitting() {
      let isProduct = true;
      const lantEnv = ['test', 'dev'];
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      lantEnv.forEach((m) => {
        if (window.location.hostname.toString().includes(m)) {
          isProduct = false;
          // eslint-disable-next-line no-unused-expressions
          m === 'dev' ? setUserZnEnv('dev') : setUserZnEnv('sit');
          setUserSys(_this.logoUi.appId);
        }
      });
      return isProduct;
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      this.initenv();
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(()=>{
            if (res.id) {
              this.$store.commit('emptyTab');
              if(getLogo().appId == '100001'){
                this.$router.push('/live/home');
              }else {
                this.$router.push('/');
              }

            }
          })
        });
    },
  },
};
</script>
